// Conveniently import this file anywhere to use db
import {config} from '@src/config';
import firebase from "firebase/app";
import 'firebase/firestore'
import 'firebase/database'
import 'firebase/auth'
import 'firebase/functions'
import 'firebase/storage';
// import 'firebase/storage' // Use lazy loading, on include common/FileUtils.js firebase/storage will be load
// import 'firebase/performance';
// import 'firebase/analytics';

//
// <!-- Load the Firebase SDKs before loading this file -->
// <script src="/__/firebase/init.js"></script>
//
// fetch('/__/firebase/init.json').then(async response => {
//   firebase.initializeApp(await response.json());
// });


if (!firebase.apps.length) {
  firebase.initializeApp(config.firebase);
}
const app = firebase.app();
// firebase.firestore().settings({cacheSizeBytes: 3e+8});
// firebase.firestore().enablePersistence({synchronizeTabs: true}).catch((err)=>{
//   console.error('Firestore, Erro ao habilitar Persistência, pode ser que tenha outra aba aberta do sistema', err);
// });

// firebase.firestore().enablePersistence({experimentalTabSynchronization: true});
// firebase.firestore().enablePersistence({synchronizeTabs: true});
// firebase.analytics();

// window.firebaseDatabaseOld = firebase.initializeApp({
//   databaseURL: "https://musicvoxtomold-db160.firebaseio.com/"
// }, 'firebaseDatabaseOld');

// Debug functions local http and onCall
// if (process.env.NODE_ENV == 'local') {
//   // firebase.functions().useFunctionsEmulator("http://localhost:5000"); // old
//   // firebase.firestore().useEmulator('localhost', 8080)                 // old


//   // firebase.app().functions().useEmulator('localhost', 5000);
//   // firebase.app().functions(config.region).useEmulator('localhost', 5000);

//   // Connect Firestore to emulator
//   firebase.firestore().useEmulator('localhost', process.env.VUE_APP_FIRESTORE_EMULATOR_PORT);

//   // Connect RTDB to emulator
//   firebase.database().useEmulator('localhost', process.env.VUE_APP_DATABASE_EMULATOR_PORT);

//   // Connect Functions to emulator
//   firebase.app().functions(config.region).useEmulator('localhost', process.env.VUE_APP_FUNCTIONS_EMULATOR_PORT);

//   // Connect Storage to emulator
//   firebase.storage().useEmulator('localhost', process.env.VUE_APP_STORAGE_EMULATOR_PORT);

//   // Connect Authentication to emulator
//   firebase.auth().useEmulator(`http://localhost:${process.env.VUE_APP_AUTH_EMULATOR_PORT}`);

//   // window.firebaseDev = firebase.initializeApp(config.firebase, 'VoxtomDev');
// }

if (window) {
  window.firebaseDebug = firebase;
  window.firebaseProd = app;
}

const { Timestamp, GeoPoint, FieldValue } = firebase.firestore;
const functions = firebase.app().functions(config.region);
const firestore = firebase.firestore();



async function fcmGetByDocsIds(ref, ids) {
  return fcmGetByPropIds(ref, firebase.firestore.FieldPath.documentId(), ids);
}
// Max values of an 'in' filter in the Firebase JS SDK 8
const IN_QUERY_LIMIT = 10;

async function fcmGetByPropIds(ref, prop, ids, op='in') {
  ref = ref || firestore;
  const chunks = [];
  for (let i=0;i<ids.length;i = i+IN_QUERY_LIMIT) {
    chunks.push(ids.slice(i, i+IN_QUERY_LIMIT));
  }
  const snapshots = await Promise.all(chunks.map(chunk => ref.where(prop, op, chunk).get()));
  const result = [];
  for (const trs of snapshots) {
    for(const trObj of trs.docs) {
      result.push({
        ...trObj.data(),
        id: trObj.id
      });
    }
  }
  return result;
}





export { Timestamp, GeoPoint, FieldValue, firestore, functions, firebase, fcmGetByPropIds, fcmGetByDocsIds};
